import React, { useCallback, Suspense } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import AddFMDExam from './AddFMDExam';
import Helmet from 'react-helmet';
import LoadingIndicator from '../../../../components/Loading/LoadingIndicator';
import { Spinner } from 'react-bootstrap';

type Props = {
  appLoading: boolean;
};

function FMDExams({ appLoading }: Props) {
  const { page } = useParams();
  const { t } = useTranslation();
  const renderActiveTab = useCallback(() => {
    let tab;
    switch (page) {
      case 'create': {
        tab = <AddFMDExam />;
        break;
      }
      default: {
        tab = <AddFMDExam />;
      }
    }

    return (
      <Suspense fallback={<LoadingIndicator />}>
        <Helmet>
          <title>{t('pageTitles:pendingPatients2') + t('pageTitles:tail')}</title>
        </Helmet>
        {tab}
      </Suspense>
    );
  }, [page]);

  if (appLoading) {
    return <Spinner variant="primary" animation="grow" />;
  }

  return renderActiveTab();
}

FMDExams.propTypes = {};

export default FMDExams;
